// extracted by mini-css-extract-plugin
export default {"tableRow":"propertyList_tableRow__IcREf","tableCell":"propertyList_tableCell__cX3Yx"};